import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appDynamicTabs]'
})
export class DynamicTabsDirective {
  constructor(public viewContainer: ViewContainerRef) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/directive/dynamic-tabs/dynamictab.component.ts